import React, { Component, Suspense } from 'react'
import { HashRouter, Route, Routes } from 'react-router-dom'
import { CSpinner } from '@coreui/react-pro'
import './scss/style.scss'
import 'react-toastify/dist/ReactToastify.css'
import { ToastContainer } from 'react-toastify'

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))
const Login = React.lazy(() => import('./layout/Login'))
const Share = React.lazy(() => import('./layout/Share'))
const ResetPassword = React.lazy(() => import('./layout/ResetPassword'))
const CompactMode = React.lazy(() => import('./layout/CompactMode'))
const SSO = React.lazy(() => import('./layout/SSO'))
const Page404 = React.lazy(() => import('./layout/Page404'))
const Page403 = React.lazy(() => import('./layout/Page403'))
const Page500 = React.lazy(() => import('./layout/Page500'))
const Unknown = React.lazy(() => import('./layout/Unknown'))


class App extends Component {
  render() {
    return (
      <HashRouter>
        <ToastContainer />
        <Suspense fallback={<CSpinner color="primary" />}>
          <Routes>
            <Route exact path="/share" element={<Share />} />
            <Route exact path="/resetpassword" element={<ResetPassword />} />
            <Route exact path="/compactmode" element={<CompactMode />} />
            <Route exact path="/sso" element={<SSO />} />
            <Route exact path="/page_403" element={<Page403 />} />
            <Route exact path="/page_404" element={<Page404 />} />
            <Route exact path="/page_500" element={<Page500 />} />
            <Route exact path="/unknown" element={<Unknown />} />
            <Route exact path="/" element={<Login />} />
            <Route path="/*" element={<DefaultLayout />} />
          </Routes>
        </Suspense>
      </HashRouter>
    )
  }
}

export default App
